import React, { useEffect } from 'react';
import styles from './HomePage.module.css'; // Import module-specific styles
import dashboard from '../../Assets/Home/dashboard-Image.png'; // Import asset images and icons
import circle from '../../Assets/Home/circleBlur.png';
import icon1 from '../../Assets/Home/Icon 1.svg'; 
import icon2 from '../../Assets/Home/Icon 2.svg';
import icon3 from '../../Assets/Home/Icon 3.svg';
import icon4 from '../../Assets/Home/Icon 4.svg';
import icon5 from '../../Assets/Home/Icon 5.svg';
import icon6 from '../../Assets/Home/Icon 6.svg';
import icon from '../../Assets/Home/Icon.svg';
import image4 from '../../Assets/Home/Image.png';
import logo1 from '../../Assets/Home/Logo 1.png';
import logo2 from '../../Assets/Home/Logo 2.png';
import logo3 from '../../Assets/Home/Logo 3.png';
import logo4 from '../../Assets/Home/Logo 4.png';
import logo5 from '../../Assets/Home/Logo 5.png';
import fIcon1 from '../../Assets/Home/Feature-Icon1.png';
import fIcon2 from '../../Assets/Home/Feature-Icon2.png';
import fIcon3 from '../../Assets/Home/Feature-Icon3.png';
import person1 from '../../Assets/Home/person1.png';
import person2 from '../../Assets/Home/person2.png';
import person3 from '../../Assets/Home/person3.png';

const HomePage = () => {
  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.home}>
      {/* Section 1 */}
      <div className={styles.home1}>
        <img src={circle} className={styles.home1Image} alt="Blurred circle" />
        <h1>The Best Software to Grow your Sales and Services</h1>
        <p className = "pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.</p>
        <div className={styles.home1Submit}>
          <input type="text" name="email" placeholder="Enter your Email" />
          <button>Get Free Trial</button>
        </div>
        <img style={{ width: 1024, marginBottom: 40 }} src={dashboard} alt="Dashboard view" />
      </div>

      {/* Section 2 */}
      <div className={styles.home2}>
        <h4>High-Quality</h4>
        <h2>We have the Best Solution for your Business</h2>
        <div className={styles.home2Section}>
          <div className={styles.home2SecItem}>
            <img src={icon1} alt="High security icon" />
            <span>High security to protect from piracy</span>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
          </div>
          <div className={styles.home2SecItem}>
            <img src={icon2} alt="Premium quality icon" />
            <span>Premium quality performance</span>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
          </div>
          <div className={styles.home2SecItem}>
            <img src={icon3} alt="24/7 support icon" />
            <span>Full time customer support - 24/7</span>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className={styles.home3}>
        <div className={styles.home3Left} style={{ width: 576 }}>
          <h4>Why should you work with us?</h4>
          <h2 style={{ marginBottom: 28 }}>To upscale your business to the next level</h2>
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua invidunt ut labore.</p>
        </div>
        <div className={styles.home3Right} style={{ width: 576 }}>
          <div className={styles.home3RightItem}>
            <img src={icon} alt="Feature icon" />
            <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.</span>
          </div>
          <div className={styles.home3RightItem}>
            <img src={icon} alt="Feature icon" />
            <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.</span>
          </div>
          <div className={styles.home3RightItem}>
            <img src={icon} alt="Feature icon" />
            <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.</span>
          </div>
        </div>
      </div>

      {/* Section 4 */}
      <div className={styles.home4}>
        <div className={styles.home4Content}>
          <div className={styles.home4Left} style={{ width: 576 }}>
            <h2>More impressions, more conversions</h2>
            <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua invidunt ut labore.</p>
            <button>Get Free trial</button>
          </div>
          <div className={styles.home4Right}>
            <img src={image4} alt="Charts and graphs" style={{ width: 576 }} />
          </div>
        </div>
      </div>

      {/* Section 5 */}
      <div className={styles.home5}>
        <img src={logo1} alt="Company logo 1" />
        <img src={logo2} alt="Company logo 2" />
        <img src={logo3} alt="Company logo 3" />
        <img src={logo4} alt="Company logo 4" />
        <img src={logo5} alt="Company logo 5" />
      </div>

      {/* Section 6 */}
      <div className={styles.home6}>
        <div className={styles.home6Left}>
          <h4>Discover More</h4>
          <h2>Analyze your sales and marketing leads</h2>
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua invidunt ut labore.</p>
        </div>
        <div className={styles.home6Right}>
          <div className={styles.home6RightItem}>
            <img src={fIcon1} alt="Sales tracking icon" />
            <div className={styles.home6RightItemSec}>
              <h4>Sales Tracking</h4>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
            </div>
          </div>
          <div className={styles.home6RightItem}>
            <img src={fIcon2} alt="Project management icon" />
            <div className={styles.home6RightItemSec}>
              <h4>Project Management</h4>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
            </div>
          </div>
          <div className={styles.home6RightItem}>
            <img src={fIcon3} alt="Activity report icon" />
            <div className={styles.home6RightItemSec}>
              <h4>Activity Report</h4>
              <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 7 */}
      <div className={styles.home7}>
        <h2>Features</h2>
        <div className={styles.home7Bottom}>
          <div className={styles.home7BItem}>
            <img src={icon4} alt="Advanced encryption icon" />
            <h3>Advanced 256-bit encryption</h3>
            <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
          </div>
          <div className={styles.home7BItem}>
            <img src={icon5} alt="Collaboration tools icon" />
            <h3>Simple collaboration tools</h3>
            <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
          </div>
          <div className={styles.home7BItem}>
            <img src={icon6} alt="Customizable AI features icon" />
            <h3>Customizable AI features</h3>
            <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor.</p>
          </div>
        </div>
      </div>
      {/* Section 8 */}
      <div className={styles.home8}>
        <h2>The stunning results our customers have experienced</h2>
        <div className={styles.home8Bottom}>
          <div className={styles.home8BItem}>
            <span className={styles.home8BTop}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</span>
            <img src={person2} alt="Ron Wood, CEO" />
            <span className={styles.home8BMiddle}>Ron Wood</span>
            <span className={styles.home8BBottom}>CEO</span>
          </div>
          <div className={styles.home8BItem}>
            <span className={styles.home8BTop}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</span>
            <img src={person3} alt="Mark Mason, Marketing Manager" />
            <span className={styles.home8BMiddle}>Mark Mason</span>
            <span className={styles.home8BBottom}>Marketing Manager</span>
          </div>
          <div className={styles.home8BItem}>
            <span className={styles.home8BTop}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</span>
            <img src={person1} alt="Sam Preston, CTO" />
            <span className={styles.home8BMiddle}>Sam Preston</span>
            <span className={styles.home8BBottom}>CTO</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;